import { render } from "./EditDate.vue?vue&type=template&id=4db5b13a&scoped=true"
import script from "./EditDate.vue?vue&type=script&lang=js"
export * from "./EditDate.vue?vue&type=script&lang=js"

import "./EditDate.vue?vue&type=style&index=0&id=4db5b13a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db5b13a"]])

export default __exports__